import axios from "axios";

export const config = {
  podarJuniors: "http://88.222.215.163:8088"
};

export const InvokeApi = async (url, params = {}) => {
    try {
        const headers = {
            "Content-Type": "application/json",
            platform: "web",
        };
        return await axios.post(url, params, { headers: headers });
    } catch ({ response }) {
        return response;
    }
};

export const apiList = {
    getArticleByOgUrl: '/article/getArticleByOgUrl',
    getArticles:'/article/getArticles',
}